import React from 'react'
import { XAxis, XAxisProps } from 'recharts'
import YearlyTick from './YearlyTick'
import MonthlyTick from './MonthlyTick'

type Props = Partial<XAxisProps> & {
  monthFormat?: 'full' | 'three' | 'one'
  chartType?: 'line' | 'bar'
  barSize?: number
  monthlyInterval?: number
}

const CustomXAxis = ({
  monthFormat = 'full',
  chartType = 'line',
  barSize = 0,
  monthlyInterval = 0,
  ...xAxisProps
}: Props) => {
  const props: XAxisProps = {
    tickSize: 0,
    tickLine: false,
    axisLine: false,
    ...xAxisProps
  }

  return (
    <>
      <XAxis
        dataKey="date"
        interval={monthlyInterval}
        tick={<MonthlyTick monthFormat={monthFormat} />}
        {...props}
      />
      <XAxis
        tickSize={0}
        interval={0}
        dataKey="date"
        xAxisId="year"
        axisLine={false}
        tickLine={false}
        tick={<YearlyTick chartType={chartType} barSize={barSize} />}
        {...props}
      />
    </>
  )
}

export default CustomXAxis
